<atn-ds-widget title="General">
  <ng-container actions>
    @if (canEditZoneSg()) {
      <i
        class="atn-icon atn-edit atn-blue"
        (click)="editClickHandler()"
      ></i>
    }
  </ng-container>
  <div class="atn-zone-general-tab">
    <div
      class="atn-zone-general-tab__field"
      data-test-id="name-field"
    >
      <span><b>Name</b></span>
      <atn-ds-value [value]="nameSg()" />
    </div>
    <div
      class="atn-zone-general-tab__field"
      data-test-id="alias-field"
    >
      <span><b>Alias</b></span>
      <atn-ds-value [value]="aliasSg()" />
    </div>
    <div
      class="atn-zone-general-tab__field"
      data-test-id="code-field"
    >
      <span><b>Code</b></span>
      <atn-ds-value [value]="codeSg()" />
    </div>
    <div
      class="atn-zone-general-tab__field"
      data-test-id="description-field"
    >
      <span><b>Description</b></span>
      <atn-ds-value [value]="descriptionSg()" />
    </div>
  </div>
</atn-ds-widget>

<atn-admin-zone-modal />
